import { render } from "./ClientMaster.vue?vue&type=template&id=5dd13dd7&scoped=true"
import script from "./ClientMaster.vue?vue&type=script&lang=js"
export * from "./ClientMaster.vue?vue&type=script&lang=js"

import "./ClientMaster.vue?vue&type=style&index=0&id=5dd13dd7&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\E-TICKET\\eticket\\ui-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dd13dd7"]])

export default __exports__